// components/ConfirmDialog.tsx
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

type ConfirmDialogProps = {
  open: boolean;
  title?: string;
  message?: string;
  onClose: () => void;       // 아니오
  onConfirm: () => void;     // 예
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
};

export default function ConfirmDialog({
  open,
  title = "확인",
  message = "정말로 진행하시겠습니까?",
  onClose,
  onConfirm,
  confirmText = "예",
  cancelText = "아니오",
  loading = false,
}: ConfirmDialogProps) {
  return (
    <Dialog open={open} onClose={loading ? undefined : onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>{cancelText}</Button>
        <Button onClick={onConfirm} disabled={loading} variant="contained">
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
